import { useEffect, useRef } from "react";
import { UseIntersectionObserverProps } from "./types";

export const useIntersectionObserver = ({
  callback,
  rootMargin = "0px",
  triggerOnce = false,
}: UseIntersectionObserverProps) => {
  const observerTarget = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = observerTarget.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          callback();

          if (triggerOnce) {
            observer.unobserve(element);
          }
        }
      },
      { rootMargin }
    );

    observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, [callback, rootMargin, triggerOnce]);

  return { observerTarget };
};
